import { render, staticRenderFns } from "./CloudBackupRestore.vue?vue&type=template&id=cdf206ac&scoped=true&"
import script from "./CloudBackupRestore.vue?vue&type=script&lang=js&"
export * from "./CloudBackupRestore.vue?vue&type=script&lang=js&"
import style0 from "./CloudBackupRestore.vue?vue&type=style&index=0&id=cdf206ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf206ac",
  null
  
)

export default component.exports